import { ChevronDown, SlidersHorizontal } from 'lucide-react';
import type { JSX } from 'react';
import styles from './FiltresRepliables.module.css';

export { styles as filtresRepliables };

export interface BasculeFiltresProps {
  /** Libellé du bouton : le titre « Filtres » de l'écran. */
  titre: string;
  /** Nombre de filtres actifs, rappelé sur le bouton même replié. */
  actifs: number;
  ouvert: boolean;
  onBasculer: () => void;
  /** Identifiant de la zone dépliée (`aria-controls`), quand elle est un seul bloc. */
  controle?: string;
}

/**
 * Bouton « Filtres » visible sous 768 px seulement. La zone qu'il commande
 * porte `filtresRepliables.repliable` ; son conteneur `filtresRepliables.racine`
 * et l'attribut `data-ouvert`.
 */
export function BasculeFiltres({
  titre,
  actifs,
  ouvert,
  onBasculer,
  controle,
}: BasculeFiltresProps): JSX.Element {
  return (
    <button
      type="button"
      className={styles.bascule}
      aria-expanded={ouvert}
      aria-controls={controle}
      onClick={onBasculer}
    >
      <SlidersHorizontal size={16} strokeWidth={1.5} aria-hidden />
      {titre}
      {actifs > 0 ? <span className={styles.compte}>{actifs}</span> : null}
      <ChevronDown size={16} strokeWidth={1.5} className={styles.chevron} aria-hidden />
    </button>
  );
}
